import React from "react";

import { Box } from "@mui/material";
import { Header } from "../../components/Header";
import { BarChart } from "../../components/BarChart";
export const Bar = () => {
  return (
    <Box m="20px">
      <Header title="Bar Chart" subtitle="Simple Bar Chart"></Header>
      <Box height="75vh">
        <BarChart isDashboard={false} />
      </Box>
    </Box>
  );
};
